import React from 'react'

import Col from 'react-bootstrap/Col'

import Accordion from '../../accordion'

const TeacherContentStudentAccordion = (props) => {
  return (
    <Col xs={12}>
      <Accordion
        id="student-accordion-header"
        title={props.title}
        open={props.open}
        children={props.children}
        setStudentAccordionState={props.setStudentAccordionState}
      />
    </Col>
  )
}

export default TeacherContentStudentAccordion